<!-- filepath: /Users/minus4/Kod/Bitbucket/new-muzible-www-login/src/components/WalletApp.vue -->
<template>
  <div class="wallet-app">
    <!-- Wallet Container -->
    <div class="wallet-container" :class="{ 'wallet-expanded': showWallet }">
      <!-- Wallet Header - Always Visible -->
      <div class="wallet-header" @click="toggleWallet">
        <div class="wallet-header-content">
          <!-- Left Side - Status & Logo -->
          <div class="wallet-status">
            <transition name="fade" mode="out-in">
              <div v-if="!isMetamaskActive" class="status-inactive">
                <span class="status-text">Activate Wallet</span>
              </div>
              <div v-else class="status-active">
                <v-img 
                  :src="require('@/assets/icons/MetaMask_Fox.svg')" 
                  contain 
                  width="24" 
                  height="24"
                  class="metamask-logo"
                />
                <span class="status-text">Connected</span>
              </div>
            </transition>
          </div>

          <!-- Right Side - Balance & Toggle -->
          <div class="wallet-summary">
            <transition name="fade" mode="out-in">
              <div v-if="isMetamaskActive" class="balance-display">
                <span class="balance-amount">{{ getMetamaskBalance }}</span>
                <span class="balance-currency">MUZ</span>
              </div>
              <div v-else class="connect-prompt">
                <span class="connect-text">Connect</span>
              </div>
            </transition>
            
            <v-icon 
              :class="{ 'icon-rotated': showWallet }"
              class="toggle-icon"
              size="20"
              style="color:white!important;"
            >
              mdi-chevron-down
            </v-icon>
          </div>
        </div>
      </div>

      <!-- Wallet Body - Expandable -->
      <transition name="slide-down">
        <div v-if="showWallet" class="wallet-body">
          <!-- MetaMask Section -->
          <div class="wallet-section">
            <div class="section-header">
              <v-img 
                :src="require('@/assets/icons/metamask.svg')" 
                contain 
                width="60" 
                height="60"
                class="metamask-image"
              />
            </div>

            <div class="section-content">
              <!-- Install MetaMask -->
              <v-btn
                v-if="isLogged && !getMetamaskIsLoaded"
                @click="downloadMetamask()"
                class="wallet-action-btn primary"
                block
              >
                <v-icon left size="18">mdi-download</v-icon>
                Install MetaMask
              </v-btn>

              <!-- Connect MetaMask -->
              <v-btn
                v-if="isLogged && getMetamaskIsLoaded && !getMetemaskWalletVisible"
                @click="connectMetamask()"
                class="wallet-action-btn primary"
                block
              >
                <v-icon left size="18">mdi-link-variant</v-icon>
                Connect Wallet
              </v-btn>

              <!-- Activate MetaMask -->
              <v-btn
                v-if="isLogged && getMetemaskWalletVisible && !isMetamaskActive"
                @click="activateMetamaskModal()"
                class="wallet-action-btn success"
                block
              >
                <v-icon left size="18">mdi-check-circle</v-icon>
                Activate Wallet
              </v-btn>

              <!-- Deactivate MetaMask -->
              <v-btn
                v-if="isLogged && getMetemaskWalletVisible && isMetamaskActive"
                @click="deactivateMetamask()"
                class="wallet-action-btn danger"
                block
              >
                <v-icon left size="18">mdi-power</v-icon>
                Deactivate
              </v-btn>

              <!-- Wallet Address Display -->
              <div v-if="isMetamaskActive && getMetamaskWallet" class="wallet-address">
                <div class="address-label">
                  <v-icon size="14">mdi-wallet</v-icon>
                  <span>Wallet Address</span>
                </div>
                <div class="address-value">
                  {{ formatAddress(getMetamaskWallet.metaMaskAddress) }}
                </div>
              </div>
            </div>
          </div>

          <!-- Info Footer -->
          <div class="wallet-footer">
            <v-icon size="14" class="info-icon" style="color:white!important;">mdi-information</v-icon>
            <span class="info-text">Secure connection via MetaMask</span>
          </div>
        </div>
      </transition>
    </div>

    <!-- Hidden MetaMask Component -->
    <vue-metamask 
      v-if="isLogged"
      :key="connectwallet"
      userMessage="Muzible" 
      @onComplete="onComplete"
      class="hidden-metamask"
    />

    <!-- Activation Modal -->
    <v-dialog
      v-model="activateMetamaskPassEnterBox"
      max-width="460"
      persistent
      class="metamask-dialog"
    >
      <v-card class="metamask-card">
        <!-- Header -->
        <v-card-title class="metamask-header">
          <div class="header-content">
            <div class="header-logo">
              <LogoWhite />
            </div>
            <h3 class="header-title">Activate Wallet</h3>
          </div>
        </v-card-title>

        <!-- Content -->
        <v-card-text class="metamask-content">
          <!-- Info Section -->
          <div class="info-section">
            <v-icon size="20" color="warning" class="info-icon">mdi-shield-lock</v-icon>
            <p class="info-text">
              Enter your password to securely activate your MetaMask wallet connection for transactions.
            </p>
          </div>

          <!-- Password Form -->
          <v-form ref="formsignupm" v-model="valid" id="check-signup-formm">  
            <v-text-field
              autocomplete="current-password"
              class="metamask-password-field"
              v-model.lazy="pass"
              label="Enter Password"
              :append-icon="value ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="() => (value = !value)"
              :type="value ? 'password' : 'text'"
              :rules="passwordRules"
              @input="pass = $event.target.value"
              required
              color="white"
              @focus="checkErrorsMetamask()"
              :error-messages="passwordErrors"
              variant="outlined"
            />
          </v-form>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="metamask-actions">
          <v-btn
            variant="text"
            color="white"
            @click="closeActivationModal"
            class="cancel-btn"
          >
            <v-icon left size="18">mdi-close</v-icon>
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            type="submit"
            form="check-signup-formm"
            :disabled="!valid"
            variant="flat"
            color="primary"
            class="activate-btn"
            @keyup.enter.native="activateMetamask($event)"
            @click="activateMetamask($event)"
          >
            <v-icon left size="18">mdi-wallet-plus</v-icon>
            Activate Wallet
          </v-btn>
        </v-card-actions>
      </v-card>    
    </v-dialog>
  </div>
</template>

<script>
import { store } from '@/store/store.js'
import VueMetamask from 'vue-metamask';
import Web3 from 'web3'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import LogoWhite from '../components/logo_white.vue';

export default {
    name: 'WalletApp',
    components: {
        VueMetamask,
        LogoWhite
    },
    setup() {
        const notify = (message) => {
            toast(message, {
                theme: "dark",
                type: "success",
                position: "bottom-center",
                closeOnClick: false,
                pauseOnHover: false,
                autoClose: 1500,
                transition: "flip",
                dangerouslyHTMLString: true,
            });
        };

        const notifyError = (message) => {
            toast(message, {
                theme: "dark",
                type: "error",
                position: "bottom-center",
                closeOnClick: false,
                pauseOnHover: false,
                autoClose: 3000,
                transition: "flip",
                dangerouslyHTMLString: true,
            });
        };

        return { notify, notifyError }
    },
    data: () => ({
        showWallet: false,
        connectwallet: 1,
        activateMetamaskPassEnterBox: false,
        passwordErrors: [],
        pass: '',
        value: true,
        valid: false,
        passwordRules: [
            v => !!v || 'Password is required', 
            v => (v && v.length >= 5) || 'Password must have 5+ characters',
        ],
    }),
    created() {
        this.emitter.on('activateMetamaskPassEnter', () => {
            this.activateMetamaskPassEnterBox = true;
            this.passwordErrors = [];
        })
        this.$store.dispatch('getLifeTokenABI');
        this.$store.dispatch('getLifeTokenAddress');
        this.$store.dispatch('getLifeMasterAddress');
        this.emitter.on('refreshMetamaskBalance', () => {
            this.refreshMetamaskWalletBalance();
        })

        if(window.ethereum){
            window.ethereum.on('accountsChanged', function (accounts) {
                window.location.reload()
            });
            window.ethereum.on('chainChanged', function (accounts) {
                window.location.reload()
            });
            window.ethereum.on('networkChanged', function(networkId){
                window.location.reload()
            });
        }
    },
    computed: {
        isLogged() {
            return this.$store.getters.getUserData != null;
        },
        isMetamaskActive() {
            return this.$store.getters.getIsMetamaskWalletActive;
        },
        getMetamaskObject(){
            return this.$store.getters.getMetamaskObject;
        },
        getMetamaskWallet(){
            return this.$store.getters.getMetamaskWallet;
        },
        getMetemaskWalletVisible(){
            return this.$store.getters.getMetamaskWallet != null;
        },
        getMetamaskIsLoaded() {
            return this.$store.getters.getMetamaskIsLoaded;
        },
        getMetamaskBalance(){
            return this.$store.getters.getMetamaskBalance;
        },
    },
    watch: {
        '$store.state.metamask': function(){
            if (this.$store.getters.getMetamaskObject === null){
                this.$store.dispatch('deactivateMetamaskWallet');
            }
        },
    },
    methods: {    
        toggleWallet() {
            this.showWallet = !this.showWallet;
        },
        
        formatAddress(address) {
            if (!address) return '';
            return `${address.substring(0, 12)}...${address.substring(address.length - 6)}`;
        },

        checkErrorsMetamask() {
            if ((this.passwordErrors['Service is down.. Try again later!'] !== 'undefined' ||
                this.passwordErrors['Bad Password..'] !== 'undefined')){
                this.passwordErrors = [];
            }
        },

        closeActivationModal() {
            this.activateMetamaskPassEnterBox = false;
            this.pass = '';
            this.valid = false;
            this.passwordErrors = [];
        },

        onComplete(data){
            var data_empty = null;
            if (data.type==="MAINNET"){
                this.$store.dispatch('setMetamaskWallet', data);
                this.refreshMetamaskWalletBalance();
            } else if (data.type==="NO_LOGIN"){
                this.$store.dispatch('setMetamaskWallet', data_empty);
                this.$store.dispatch('deactivateMetamaskWallet');
            } else {
                this.$store.dispatch('setMetamaskWallet', data_empty);
                this.$store.dispatch('deactivateMetamaskWallet');
            }
        },

        setMetamaskBalance (balance) {
            this.$store.dispatch('setMetamaskBalance', balance);
        },

        downloadMetamask() {
            window.open("https://metamask.io/download", "_blank");  
        },

        connectMetamask() {
            this.connectwallet = this.connectwallet+1;
        },

        activateMetamaskModal() {
            this.pass = '';
            this.valid = false;
            this.passwordErrors = [];
            this.value = true;
            
            this.$store.dispatch('checkMetamaskAddress', { address: this.$store.getters.getMetamaskWallet.metaMaskAddress } )
                .then( response => {
                    this.emitter.emit('activateMetamaskPassEnter');
                })
                .catch( error => {
                    this.notifyError("Error occured.. Please try again later.");
                })
        },

        activateMetamask(event) {
            event.preventDefault()
            this.$store.dispatch('checkandgetMetamaskWallet', { 
                token: this.$store.getters.getUserData.token,
                address: this.$store.getters.getMetamaskWallet.metaMaskAddress, 
                pass: this.pass
            })
            .then( response => {
                this.activateMetamaskPassEnterBox = false;
                if (response.ok){
                    this.showWallet = false;
                    this.$store.dispatch('activateMetamaskWallet');
                    this.refreshMetamaskWalletBalance();
                    this.notify("Wallet activated successfully!");
                } else {
                    this.$store.dispatch('deactivateMetamaskWallet');
                    this.notifyError("Wallet already connected.");
                }
            })
            .catch( error => {
                if (!error.response){
                    this.passwordErrors = ['Service is down.. Try again later!'];   
                } else {
                    this.passwordErrors = ['Bad Password..'];
                }
                this.$store.dispatch('deactivateMetamaskWallet');
            });
        },

        refreshMetamaskWalletBalance() {
            if (this.$store.getters.getMetamaskWallet && this.$store.getters.getMetamaskWallet.web3){
                const tokenInst = new this.$store.getters.getMetamaskWallet.web3.eth.Contract(
                    this.$store.getters.getLifeTokenABI, 
                    this.$store.getters.getLifeTokenAddress
                );
                tokenInst.methods.decimals().call().then(res => {
                    this.$store.dispatch('setdecimals', { decimals: res} )
                    tokenInst.methods.balanceOf(this.$store.getters.getMetamaskWallet.metaMaskAddress).call()
                    .then(res => {
                        this.setMetamaskBalance(parseFloat(res/(10 ** this.$store.getters.getDecimals)));
                    });
                })
            }
        },

        deactivateMetamask() {
            this.$store.dispatch('deactivateMetamaskWallet');
            this.showWallet = false;
            this.notify("Wallet deactivated");
        },
    },
}
</script>

<style lang="scss" scoped>
@use '/src/views/css/styles.scss';

/* Wallet App Container */
.wallet-app {
  width: 100%;
  height: 100%;
}

.hidden-metamask {
  display: none;
}

/* Wallet Container */
.wallet-container {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.98), rgba(18, 18, 18, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-top-left-radius: 0; /* Usuń border-radius z góry po lewej */
  border-bottom-left-radius: 0; /* Usuń border-radius z dołu po lewej */
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  border-left: none; /* Usuń border z lewej - łączy się z buttonem */
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.4); /* Shadow tylko z prawej */
  backdrop-filter: blur(10px);
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: all 0.3s ease;
}

.wallet-container:hover {
  box-shadow: 6px 6px 16px rgba(0, 0, 0, 0.5);
}

/* Wallet Header */
.wallet-header {
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.wallet-header:hover {
  background: rgba(255, 255, 255, 0.05);
}

.wallet-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

/* Wallet Status */
.wallet-status {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.status-inactive,
.status-active {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-icon {
  color: rgba(255, 255, 255, 0.6) !important;
}

.metamask-logo {
  flex-shrink: 0;
}

.status-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: white;
  white-space: nowrap;
}

/* Wallet Summary */
.wallet-summary {
  display: flex;
  align-items: center;
  gap: 12px;
}

.balance-display {
  display: flex;
  align-items: baseline;
  gap: 6px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 8px;
}

.balance-amount {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: white;
}

.balance-currency {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
}

.connect-prompt {
  display: flex;
  align-items: center;
}

.connect-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
}

.toggle-icon {
  color: rgba(255, 255, 255, 0.6) !important;
  transition: transform 0.3s ease;
}

.icon-rotated {
  transform: rotate(180deg);
}

/* Wallet Body */
.wallet-body {
  padding: 20px;
}

.wallet-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.section-header {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

.metamask-image {
  filter: drop-shadow(0 4px 12px rgba(0, 123, 255, 0.3));
}

.section-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Wallet Action Buttons */
.wallet-action-btn {
  height: 48px !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  border-radius: 10px !important;
  transition: all 0.3s ease;
}

.wallet-action-btn.primary {
  background: linear-gradient(135deg, #007bff, #0056b3) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.wallet-action-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);
}

.wallet-action-btn.success {
  background: linear-gradient(135deg, #28a745, #1e7e34) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.wallet-action-btn.success:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
}

.wallet-action-btn.danger {
  background: linear-gradient(135deg, #dc3545, #bd2130) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

.wallet-action-btn.danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(220, 53, 69, 0.4);
}

/* Wallet Address */
.wallet-address {
  padding: 14px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.address-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.address-value {
  font-family: "Courier New", monospace;
  font-size: 14px;
  font-weight: 600;
  color: white;
  width: 100%;
  word-break: break-all;
}

/* Wallet Footer */
.wallet-footer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  background: rgba(0, 123, 255, 0.1);
  border: 1px solid rgba(0, 123, 255, 0.2);
  border-radius: 8px;
  margin-top: 16px;
}

.info-icon {
  color: #007bff !important;
  flex-shrink: 0;
}

.info-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.4;
}

/* Metamask Dialog */
.metamask-dialog {
  :deep(.v-overlay__content) {
    border-radius: 16px;
  }
}

.metamask-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.98), rgba(18, 18, 18, 0.98)) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.6) !important;
}

.metamask-header {
  background: rgba(0, 0, 0, 0.5);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px !important;
}

.header-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.header-logo {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.header-logo:hover {
  transform: scale(1.05);
}

.header-title {
  margin: 0;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: white;
  text-align: center;
}

.metamask-content {
  padding: 32px 24px 24px 24px !important;
  color: white;
}

/* Info Section */
.info-section {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: rgba(255, 193, 7, 0.1);
  border-left: 3px solid #ffc107;
  border-radius: 8px;
  margin-bottom: 24px;
}

.info-section .info-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.info-section .info-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.5;
  margin: 0;
  flex: 1;
}

/* Password Field */
:deep(.metamask-password-field .v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 10px !important;
  transition: all 0.3s ease;
}

:deep(.metamask-password-field .v-field:hover) {
  border-color: rgba(255, 255, 255, 0.4) !important;
  background: rgba(255, 255, 255, 0.08) !important;
}

:deep(.metamask-password-field .v-field--focused) {
  border-color: rgba(255, 255, 255, 0.6) !important;
  background: rgba(255, 255, 255, 0.1) !important;
}

:deep(.metamask-password-field .v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
}

:deep(.metamask-password-field .v-field__input) {
  color: white !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  font-weight: 500;
  padding: 12px 16px !important;
}

:deep(.metamask-password-field .v-messages__message) {
  color: rgba(244, 67, 54, 0.9) !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 13px !important;
  margin-top: 4px;
}

:deep(.metamask-password-field .v-icon) {
  color: rgba(255, 255, 255, 0.7) !important;
}

/* Modal Actions */
.metamask-actions {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.3);
}

.cancel-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
}

.cancel-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.activate-btn {
  min-width: 180px;
  height: 44px !important;
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  border-radius: 10px !important;
  background: linear-gradient(135deg, #007bff, #0056b3) !important;
  color: white !important;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.activate-btn:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);
}

.activate-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: linear-gradient(135deg, #6c757d, #545b62) !important;
  box-shadow: none;
}

/* Animations */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-down-enter-active {
  transition: all 0.3s ease;
}

.slide-down-leave-active {
  transition: all 0.2s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
}

.slide-down-enter-to,
.slide-down-leave-from {
  opacity: 1;
  max-height: 500px;
  overflow: hidden;
}

/* Responsive */
@media (max-width: 768px) {
  .wallet-app {
    top: 70px;
    right: 16px;
  }

  .wallet-container {
    min-width: 280px;
  }

  .wallet-header {
    padding: 14px 16px;
  }

  .wallet-body {
    padding: 16px;
  }

  .metamask-content {
    padding: 24px 16px !important;
  }

  .metamask-actions {
    flex-direction: column;
    gap: 12px;
  }

  .cancel-btn,
  .activate-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .wallet-app {
    right: 12px;
    left: 12px;
  }

  .wallet-container {
    min-width: auto;
    width: 100%;
  }
}

/* Vuetify Overrides */
:deep(.v-icon) {
  color: inherit !important;
}
</style>